import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col, message } from 'antd';
import { Link } from 'react-router-dom';
import { UserOutlined, LockOutlined, CodeSandboxOutlined, RollbackOutlined } from '@ant-design/icons';
import { isLoggedIn, setAuthTokens } from 'axios-jwt';
import queryString from 'query-string';

import './login.css';
import CONSTANT from '../../config/constant';
import { autoLoginShop, axiosInstance, loginAndGetTokenShop, shopInstance } from '../../config/api';

const Login = (props) => {
    const [form] = Form.useForm();
    const [formEmail] = Form.useForm();
    const [formGetPass] = Form.useForm();
    const [, forceUpdate] = useState({});
    const [loging, setLoging] = useState(false);
    const [currentAction, setcurrentAction] = useState({ action: 'login', title: 'Đăng nhập hệ thống quản lý bán hàng Tatinta', email: '' });
    useEffect(() => {
        forceUpdate({});
        if (isLoggedIn()) window.location.href = '/';

    }, []);

    const onFinishSendEmail = async (values) => {
        setLoging(true);
        axiosInstance.post(`${CONSTANT.API.USER.CHECK}`, { email: values.email })
            .then(res => {
                if (res.data.code === 200 && res.data.data.exist === true) {
                    axiosInstance.post(`${CONSTANT.API.AUTH.FORGOT_PASS}`, { email: values.email, role: "agency" })
                        .then(async res1 => {
                            if (res1.data.code === 200 && res1.data.data) {
                                message.success('Mã xác nhận đã được gửi về email ' + values.email + '. Vui lòng kiểm tra email lấy mã và thực hiện lấy lại mật khẩu !', 2);
                                setcurrentAction({ action: 'getpass', title: "Lấy lại mật khẩu", email: values.email });
                            }
                            setLoging(false);
                        })
                        .catch(error => {
                            setLoging(false);
                            message.error('Gửi yêu cầu không thành công ! error:' + error.response.data.code + '', 2);
                        });
                }
                else if (res.data.code === 200 && res.data.data.exist === false) {
                    setLoging(false);
                    message.error('Email chưa được đăng ký, vui lòng kiểm tra lại !', 2);
                }
            })
            .catch(error => {
                setLoging(false);
                message.error('Gửi yêu cầu không thành công ' + error.response.data.code + ' !', 2);
            });
    }
    const onFinishGetPass = async (values) => {
        await axiosInstance.post(`${CONSTANT.API.AUTH.GET_PASS + '/' + values.codeGetPass}`, { email: currentAction.email, password: values.newpassword, role: "agency" })
            .then(res => {
                if (res.data.code === 200 && res.data.data) {
                    message.success('Lấy lại mật khẩu thành công ! Bây giờ bạn có thể dùng mật khẩu mới để đăng nhập !', 2);
                    setcurrentAction({ action: 'login', title: "Lấy lại mật khẩu thành công ! Bây giờ bạn có thể dùng mật khẩu mới để đăng nhập" });
                }
            })
            .catch(error => {
                if (error.response.data.code === 404) {
                    message.error('Mã xác nhận không đúng. Vui lòng kiểm tra lại !', 2);
                }
                else if (error.response.data.code === 400) {
                    message.error('Mã xác nhận không đúng. Vui lòng kiểm tra lại !', 2);
                }
            });
    }

    const onFinishLogin = async (values) => {
        await loginAndGetTokenShop(values.email, values.password)
            .then(async res => {
                setLoging(false);
                await autoLoginShop(values.email, values.password)
                let profileData = {};
                if (res && res?.user) {
                    await shopInstance.get(`${CONSTANT.API.AUTH.PROFILE}`).then(async (resP) => {
                        const { role } = resP.data.user;
                        if (role !== 'agency' && role !== 'admin') {
                            message.warning('Tài khoản này không có quyền truy hệ thống');
                            return;
                        }
                        profileData = resP.data.user;
                        localStorage.setItem(CONSTANT.STORAGE_KEY_USER, JSON.stringify(profileData));
                    })

                    await shopInstance.get(`${CONSTANT.API.AGENCY.AGENCY_INFO}/${res?.user.id}`).then(async (res2) => {
                        if (res2 && res2.data && res2.code === 200 && res2.data) {
                            localStorage.setItem("tatinta-agency", res2.data._id);
                            localStorage.setItem("tatinta-agency-type", res2.data.is_shop ? res2.data.is_shop : false);

                            message.success('Đăng nhập thành công!', 1)
                                .then(() => {
                                    let params = queryString.parse(props.location.search);
                                    let back = params.back ? params.back : '/';
                                    window.location.href = back;
                                })

                        }
                    }).catch(error => message.warning('Lỗi lấy thông tin đại lý!', 2.5))


                }
                else if (res?.code === 400) {
                    if (res?.data?.message === 'wrong_email')
                        message.error('Email không đúng!');
                    if (res?.data?.message === 'wrong_pass')
                        message.error('Mật khẩu không đúng!');
                    return;
                }
                else if (res?.code === 403) {
                    message.warning('Truy cập không được phép!'); return;
                }
                else if (res?.message) {
                    message.warning(res?.message); return;
                }
                else {
                    message.warning('Đăng nhập thất bại. Vui lòng thử lại sau!'); return;
                }
            })
    }

    return (
        <div className="bg-login login">
            <Row>
                <Col
                    lg={{ span: 12, offset: 6 }} xs={{ span: 20, offset: 2 }} sm={{ span: 12, offset: 6 }}
                    md={{ span: 12, offset: 6 }} xl={{ span: 6, offset: 9 }}
                >
                    <div className="logo">
                        <img src="tatinta.png" alt="logo" />
                    </div>
                    <div className="slogan">{currentAction.title}</div>
                    {
                        currentAction.action === 'login' ?
                            <Form
                                name="normal_login"
                                className="login-form"
                                onFinish={onFinishLogin}
                                form={form}
                            >
                                <Form.Item
                                    name="email"
                                    rules={[
                                        { type: 'email', message: 'Email không hợp lệ!' },
                                        { required: true, message: 'Vui lòng nhập Email!' },
                                    ]}
                                >
                                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" className="form-control" />
                                </Form.Item>
                                <Form.Item
                                    name="password"
                                    rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
                                >
                                    <Input.Password
                                        prefix={<LockOutlined className="site-form-item-icon" />}
                                        placeholder="Mật khẩu"
                                        className="form-control"
                                    />
                                </Form.Item>
                                <Form.Item shouldUpdate>
                                    {
                                        () => (
                                            <Button
                                                type="primary" htmlType="submit" className="login-form-button"
                                                disabled={
                                                    !form.isFieldsTouched(true) ||
                                                    !!form.getFieldsError().filter(({ errors }) => errors.length).length
                                                }
                                                loading={loging}
                                            >
                                                Đăng nhập
                                            </Button>
                                        )
                                    }

                                </Form.Item>
                                <Link className="login-form-forgot" onClick={() => setcurrentAction({ action: 'sendemail', title: 'Lấy lại mật khẩu đăng nhập' })} style={{ float: 'right' }}>
                                    Bạn quên mật khẩu ?
                                </Link>
                            </Form> : currentAction.action === 'sendemail' ?
                                <Form
                                    name="normal_login"
                                    className="login-form"
                                    onFinish={onFinishSendEmail}
                                    form={formEmail}
                                >
                                    <Form.Item
                                        name="email"
                                        rules={[
                                            { type: 'email', message: 'Email không hợp lệ!' },
                                            { required: true, message: 'Vui lòng nhập Email bạn đã đăng ký!' },
                                        ]}
                                    >
                                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Nhập Email bạn đã đăng ký" className="form-control" />
                                    </Form.Item>
                                    <Form.Item shouldUpdate>
                                        {
                                            () => (
                                                <Button
                                                    type="primary" htmlType="submit" className="login-form-button"
                                                    disabled={
                                                        !formEmail.isFieldsTouched(true) ||
                                                        !!formEmail.getFieldsError().filter(({ errors }) => errors.length).length
                                                    }
                                                    loading={loging}
                                                >
                                                    Gửi yêu cầu lấy mật khẩu
                                                </Button>
                                            )
                                        }
                                    </Form.Item>
                                    <Link className="login-form-forgot" onClick={() => setcurrentAction({ action: 'login', title: 'Đăng nhập hệ thống Tatinta Store' })}>
                                        <RollbackOutlined />  Quay lại
                                    </Link>
                                    <Link className="login-form-forgot" onClick={() => setcurrentAction({ action: 'getpass', title: 'Lấy lại mật khẩu đăng nhập' })} style={{ float: 'right' }}>
                                        Bạn đã có mã xác nhận lấy mật khẩu ?
                                    </Link>
                                </Form> : currentAction.action === 'getpass' ?
                                    <Form
                                        name="normal_login"
                                        className="login-form"
                                        onFinish={onFinishGetPass}
                                        form={formGetPass}
                                    >
                                        <Form.Item name="codeGetPass"
                                            rules={[{ required: true, message: "Mã xác nhận lấy lại mật khẩu không được để trống" }, {
                                                type: 'string', max: 6, message: "Mã xác nhận lấy lại mật khẩu không đúng"
                                            },]}>
                                            <Input prefix={<CodeSandboxOutlined className="site-form-item-icon" />} placeholder="Nhập mã xác nhận lấy lại mật khẩu" />
                                        </Form.Item>
                                        <Form.Item name="newpassword"
                                            rules={[{ required: true, message: "Mật khẩu mới không được để trống" }, {
                                                type: 'string', max: 100, message: "Mật khẩu mới quá 100 ký tự"
                                            },]}>
                                            <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Nhập mật khẩu mới" />
                                        </Form.Item>
                                        <Form.Item
                                            name="confirm"
                                            dependencies={['newpassword']}
                                            hasFeedback
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Vui lòng nhập lại mật khẩu mới!',
                                                },
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        if (!value || getFieldValue('newpassword') === value) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(new Error('Nhập lại mật khẩu mới không đúng!'));
                                                    },
                                                }),
                                            ]}
                                        >
                                            <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Nhập lại mật khẩu mới" />
                                        </Form.Item>
                                        <Form.Item shouldUpdate>
                                            {
                                                () => (
                                                    <Button
                                                        type="primary" htmlType="submit" className="login-form-button"
                                                        disabled={
                                                            !formGetPass.isFieldsTouched(true) ||
                                                            !!formGetPass.getFieldsError().filter(({ errors }) => errors.length).length
                                                        }
                                                        loading={loging}
                                                    >
                                                        Thay đổi mật khẩu
                                                    </Button>
                                                )
                                            }
                                        </Form.Item>
                                        <Link className="login-form-forgot" onClick={() => setcurrentAction({ action: 'login', title: 'Đăng nhập hệ thống Tatinta Store' })}>
                                            <RollbackOutlined />  Về đăng nhập
                                        </Link>
                                    </Form> : null
                    }
                </Col>
            </Row>
        </div >
    )

}
export default Login;